// extracted by mini-css-extract-plugin
export var configurationSection = "_zg-0";